import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { setCurrentUnitStatus, setIsLoadingUnitStatus } from '../model/configuratorSlice';
import { EndPoints } from '../model/constants';
import { FeatureSelectionUtility } from '../utilities/FeatureSelectionUtility';

export default function UnitService() {
  const {
 promotionSlug, currentUnit, token, categories,
} = useSelector(state => state.configurator);
  const dispatch = useDispatch();

  return useMutation(['unitQuery'], (payload) => {
    const featureSelection = FeatureSelectionUtility.CreateFeatureSelectionExcludingDisabledString(categories);
    const unitUrl = `${EndPoints.UnitUrl}/${promotionSlug}/unit/${currentUnit.id}/code/${featureSelection}/status`;
    axios
      .get(unitUrl)
      .then((response) => {
        dispatch(setCurrentUnitStatus(response.data));
        dispatch(setIsLoadingUnitStatus(false));
      })
      .catch((error) => {
        // dispatch(setUserLoginFailed(error.response.data));
      });
  });
}
